import React from "react";
import { Popover, MenuItem } from "@mui/material";
import Iconify from "../iconify/Iconify";
import { useNavigate } from "react-router-dom";

export default function UserMenuPopover({ open, onClose, userId }) {
  const navigate = useNavigate();

  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        sx: {
          p: 1,
          width: 180,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
          },
        },
      }}
    >
      <MenuItem
        onClick={() => navigate(`/dashboard/user-packs?user_id=${userId}`)}
      >
        <Iconify icon={"eva:gift-outline"} sx={{ mr: 2 }} />
        Packs
      </MenuItem>
      <MenuItem
        onClick={() => navigate(`/dashboard/user-cards?user_id=${userId}`)}
      >
        <Iconify icon={"eva:book-outline"} sx={{ mr: 2 }} />
        Cards
      </MenuItem>
      <MenuItem
        onClick={() =>
          navigate(`/dashboard/user-marketplace-cards?user_id=${userId}`)
        }
      >
        <Iconify icon={"eva:shopping-cart-outline"} sx={{ mr: 2 }} />
        Marketplace
      </MenuItem>
      <MenuItem
        onClick={() => navigate(`/dashboard/user-lineups?user_id=${userId}`)}
      >
        <Iconify icon={"eva:grid-outline"} sx={{ mr: 2 }} />
        Lineups
      </MenuItem>
    </Popover>
  );
}
